
import { Component, Prop, Vue } from "vue-property-decorator";
import BlackPop from "@/views/ai-builder/components/black-pop.vue";
import Editor from "@/components/editor/email-editor.vue";
import Pop from "@/views/ai-builder/components/blue-pop.vue";
import ResultTemplate from "@/lib/model/template/result";
import Url from "@/lib/common/url";
import { ZhuoMuNiao } from "@/views/news/resultInfo";

@Component({ components: { BlackPop, Editor, Pop } })
export default class SetResult extends Vue {
  @Prop({}) exam!: any;
  @Prop({}) examId!: number;
  onlyShow = false;
  title = "设置面试结果页";
  exist = false; //新建
  tabNavMap = [
    {
      label: "通过结果页",
      value: "passTemplate",
      status: "passStatus"
    },
    {
      label: "待定结果页",
      value: "waitTemplate",
      status: "waitStatus"
    },
    {
      label: "拒绝结果页",
      value: "refuseTemplate",
      status: "refuseStatus"
    }
  ];
  resultInfo = {
    waitTemplate: "",
    passTemplate: "",
    refuseTemplate: "",
    waitStatus: "0",
    passStatus: "0",
    refuseStatus: "0"
  };
  companyId = Url.query("companyId");
  activeName = "passTemplate";
  isCompanyZmn = ZhuoMuNiao.isCompanyZmn();
  tagList: object[] = [];

  async created() {
    this.getResultInfo();
  }
  tagText(tag: string) {
    return `{${tag}}`;
  }
  // 请求
  async getResultInfo() {
    const [result, connect] = await Promise.all([
      ResultTemplate.get({
        examId: this.examId,
        companyId: this.companyId
      }),
      ResultTemplate.getConnect(this.exam.connectCode)
    ]);
    this.exist = result.result;
    // 可选变量
    this.tagList = ZhuoMuNiao.tagListFilter(connect.params);
    if (ZhuoMuNiao.isZmn(connect.params)) {
      this.tagList = this.tagList.concat(ZhuoMuNiao.tagList);
    }
    this.standardResult(result);
  }
  // 回显数据处理
  standardResult(result: any) {
    for (const key in result) {
      if (key === "extraData") {
        const extraDataList = JSON.parse(result["extraData"] || "[]");
        extraDataList.forEach((extra: any) => {
          this.standardResult(extra);
        });
      }
      if (Object.prototype.hasOwnProperty.call(this.resultInfo, key)) {
        this.resultInfo[key] = result[key] || ZhuoMuNiao[key];
      }
    }
  }
  addTag(it: any, key: string) {
    (this.$refs[key] as any)[0]?.insertHtml(`{${it.name}}`);
  }

  ok() {
    const { passTemplate, waitTemplate, refuseTemplate } = this.resultInfo;
    if (passTemplate && waitTemplate && refuseTemplate) {
      const extraData = JSON.stringify([
        {
          key: "isJoinOffline",
          name: "是否参加线下面试",
          passStatus: this.resultInfo.passStatus
          // waitStatus: this.resultInfo.waitStatus,
          // refuseStatus: this.resultInfo.refuseStatus
        }
      ]);
      const params = {
        examId: this.examId,
        companyId: this.companyId,
        passTemplate: passTemplate,
        refuseTemplate: refuseTemplate,
        waitTemplate: waitTemplate,
        extraData: extraData
      };

      ResultTemplate.createOrUpdate(params)
        .then(() => {
          this.$message.success(this.exist ? "创建成功" : "保存成功");
          this.$emit("ok");
        })
        .catch(error => {
          console.log("error:", error);
          this.$message.warning(this.exist ? "创建失败" : "保存失败");
        });
    } else {
      this.$message.warning("模板内容不能为空");
    }
  }

  //关闭
  close() {
    this.$emit("cancel", false);
  }
}
